// import React from 'react';
// import {graphql} from 'react-apollo';
// import {flowRight as compose} from 'lodash';

// import queries from '../../../../../src/utils/queries'

const cliUpd = async (elementoArchivo, argsSelDpto, editCliente, editClienteUpdDocMany, editOdeSUpdDoc) => {

  //ACTUALIZAR BD
  const crudBD = async (operacionCRUD, args, i)=>{
    if(args.ctrlCampo === 'CRUD'){
        const {data} = await operacionCRUD({
        variables: args
      });
      //Se utiliza para traer el _id del documento creado
      if(args.ctrl_id === 'SI_ID'){
        if(Object.values(data)[0]._id){
          return Object.values(data)[0]._id
        }else{
          return 0
        }
      }
    }else{
      if(args.ctrlCampo === "MANY"){
        await operacionCRUD({
          variables: args
        });
      }
    }
  }

  const updColecc = async (crudColecc, argsCrud, totDocCRUD)=>{
    let codigo = 0
    if(argsCrud[0].ctrl_id === 'SI_ID'){
      codigo = await crudBD(crudColecc[0], argsCrud[0], 0)
    }else{
      await crudBD(crudColecc[0], argsCrud[0], 0)
    }
    if(codigo!==0){
      for(let i=1; i<totDocCRUD; i++){
        argsCrud[i]._id = codigo
      }
    }
    for(let i=1; i<totDocCRUD; i++){
      await crudBD(crudColecc[i], argsCrud[i], i)
    }
  }

  let args = elementoArchivo

  const argsUpd = {
    _id: args._id,
    tipoAct: "EditarCliente",
    infAdic1: args.infAdic1,
    nombreCliente: args.nombreCliente,
    apellidoCliente: args.apellidoCliente,
    sexoCliente: args.sexoCliente,
    eMail: args.eMail,
    fechaCumple: args.fechaCumple,
    descrEstrato: args.descrEstrato,
    codigoSegmento: args.codigoSegmento?args.codigoSegmento:"",
    descrSegmento: args.descrSegmento?args.descrSegmento:"",
    cicloFact: args.cicloFact,
    telefono1: args.telefono1,
    telefono2: args.telefono2,
    telefono3: args.telefono3,
    referencia1: args.referencia1,
    telefonoRef1: args.telefonoRef1,
    referencia2: args.referencia2,
    telefonoRef2: args.telefonoRef2,
    numeroDoc: args.numeroDoc,
    observacinumeroDocones: args.observaciones,
    codigoTipoCliente: args.codigoTipoCliente,
    descrTipoCliente: args.descrTipoCliente,
    idTipoDoc: args.idTipoDoc,
    codigoTipoDoc: args.codigoTipoDoc,
    descrTipoDoc: args.descrTipoDoc,
    idGrupoAf: args.idGrupoAf,
    codigoGrupoAfin: args.codigoGrupoAfin,
    descrGrupoAfin: args.descrGrupoAfin
  }
  // console.log(argsUpd)
  if(args.estadoCliente==="NUEVO"){
    delete argsUpd.cicloFact
  }
  let actCliente = []
  actCliente.push(argsUpd)

  // ACTUALIZAR DIRECCION A LOS CLIENTES
  let movColecc = []
  let argsAdd = {}

  argsAdd['tipoAct'] = "EditarDirmayor"

  if(args.estadoCliente==="NUEVO"){
    delete argsUpd.cicloFact

    //Agregar direccion a la OS
    argsAdd = {
      "tipoAct": "EditarDirmayor",
      "numeroOS": args.numeroOS,
      "codigoDpto": argsSelDpto.codigoDpto,
      "descrDpto": argsSelDpto.descrDpto,
      "codigoDptoDANE": argsSelDpto.codigoDptoDANE,
      "codigoCiudad": argsSelDpto.codigoCiudad,
      "nombreCiudad": argsSelDpto.nombreCiudad,
      "codigoMunicipioDANE": argsSelDpto.codigoMunicipioDANE,
      "codigoPostalDANE": argsSelDpto.codigoPostalDANE,
      "codigoCiudadInterno": argsSelDpto.codigoCiudadInterno,
      "codBarrasRdo": argsSelDpto.codBarrasRdo,
      "codigoZona": argsSelDpto.codigoZona,
      "nombreZona": argsSelDpto.nombreZona,
      "codigoBarrio": argsSelDpto.codigoBarrio,
      "nombreBarrio": argsSelDpto.nombreBarrio,
      "codigoTipoDocT": argsSelDpto.codigoTipoDocT,
      "numeroDocumT": argsSelDpto.numeroDocumT,
      "descrRecursoT": argsSelDpto.descrRecursoT,
      "codigoTipoDocR": argsSelDpto.codigoTipoDocR,
      "numeroDocumR": argsSelDpto.numeroDocumR,
      "descrRecursoR": argsSelDpto.descrRecursoR,

      "descrTipoVia1": args.descrTipoVia1,
      "numeroTipoVia1": args.numeroTipoVia1,
      "descrTipoVia2": args.descrTipoVia2,
      "numeroTipoVia2": args.numeroTipoVia2,
      "numeroTipoVia2F": args.numeroTipoVia2F,
      "descrTipoUnd1": args.descrTipoUnd1,
      "numeroTipoUnd1": args.numeroTipoUnd1,
      "descrTipoUnd2": args.descrTipoUnd2,
      "numeroTipoUnd2": args.numeroTipoUnd2,
    };
    if(!args.descrTipoUnd1){delete argsAdd.descrTipoUnd1}
    if(!args.numeroTipoUnd1){delete argsAdd.numeroTipoUnd1}
    if(!args.descrTipoUnd2){delete argsAdd.descrTipoUnd2}
    if(!args.numeroTipoUnd2){delete argsAdd.numeroTipoUnd2}
  }else{
    argsAdd['_id'] = args._id
    argsAdd['dirmayor'] = {codigoDpto: argsSelDpto.codigoDpto,
      descrDpto: argsSelDpto.descrDpto,
      codigoDptoDANE: argsSelDpto.codigoDptoDANE,
      ciudades: {codigoCiudad: argsSelDpto.codigoCiudad,
        nombreCiudad: argsSelDpto.nombreCiudad,
        codigoMunicipioDANE: argsSelDpto.codigoMunicipioDANE,
        codigoPostalDANE: argsSelDpto.codigoPostalDANE,
        codigoCiudadInterno: argsSelDpto.codigoCiudadInterno,
        codBarrasRdo: argsSelDpto.codBarrasRdo,
        zonas: {codigoZona: argsSelDpto.codigoZona,
          nombreZona: argsSelDpto.nombreZona,
          barrios: {codigoBarrio: argsSelDpto.codigoBarrio,
            nombreBarrio: argsSelDpto.nombreBarrio,
            descrRecursoT: argsSelDpto.descrRecursoT,
            numeroDocumT: argsSelDpto.numeroDocumT,
            codigoTipoDocT: argsSelDpto.codigoTipoDocT,
            descrRecursoR: argsSelDpto.descrRecursoR,
            numeroDocumR: argsSelDpto.numeroDocumR,
            codigoTipoDocR: argsSelDpto.codigoTipoDocR
        }}}}

    argsAdd['direccion'] = {descrTipoVia1: args.descrTipoVia1,
      numeroTipoVia1: args.numeroTipoVia1,
      descrTipoVia2: args.descrTipoVia2,
      numeroTipoVia2: args.numeroTipoVia2,
      numeroTipoVia2F: args.numeroTipoVia2F,
      descrTipoUnd1: args.descrTipoUnd1,
      numeroTipoUnd1: args.numeroTipoUnd1,
      descrTipoUnd2: args.descrTipoUnd2,
      numeroTipoUnd2: args.numeroTipoUnd2
    }
    //FIN ACTUALIZAR DIRECCION A LOS CLIENTES
  }
  movColecc.push(argsAdd)

  let actCliMany1 = []
  actCliMany1.push({cliente: movColecc})

  let numDocCRUD = 0
  let totDocCRUD = 2
  let argsCrud = []
  let crudColecc = []
  for(let iii=0; iii<totDocCRUD; iii++){
    argsCrud.push({ctrlCampo: 'NO_CRUD'})
  }
  for(let iii=0; iii<totDocCRUD; iii++){
    crudColecc.push(editCliente)
  }

  argsCrud[numDocCRUD] = actCliente[0]
  argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
  argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
  crudColecc[numDocCRUD] = editCliente

  numDocCRUD += 1

  if(args.estadoCliente==="NUEVO"){
    console.log(args.contrato, args.estadoCliente)
    argsCrud[numDocCRUD] = movColecc[0]
    argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
    argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
    crudColecc[numDocCRUD] = editOdeSUpdDoc
  }else{
    console.log(args.contrato, args.estadoCliente)
    argsCrud[numDocCRUD] = actCliMany1[0]
    argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
    argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
    crudColecc[numDocCRUD] = editClienteUpdDocMany
  }

  // console.log(argsCrud, totDocCRUD)
  await updColecc(crudColecc, argsCrud, totDocCRUD)

  const contratoAj = {contrato: args.contrato}
  // console.log(contrato)
  return contratoAj
}

export default cliUpd

// export default compose(
//   // graphql(queries.query.allMovClientes, {name:'allMovClientes', options: (props) => {return {variables: {contrato: "12", orden: '_id'}}}}),

//   // graphql(queries.mutation.editOdeS, {name:'editOdeS'}),

// )(cliUpd)
